import { MasterMessage } from '../masters/masterMessages';

const {
    activityTimes,
    exportActivityTimes,
    caseManagement,
    bulkLoad,
    caseManager,
    caseReport,
    weCallYouAdmin,
    surveys,
    users,
    chat,
    videoCall,
    weCallYou,
    videoAtencion,
    commercialCrm,
    usersCreation,
    ivrTypificationBase,
} = MasterMessage.modules;

export const listRoutesBlock = [
    {
        id: 1,
        name: activityTimes,
    },
    {
        id: 2,
        name: exportActivityTimes,
    },
    {
        id: 3,
        name: caseManagement,
    },
    {
        id: 4,
        name: bulkLoad,
    },
    {
        id: 5,
        name: caseManager,
    },
    {
        id: 6,
        name: caseReport,
    },
    {
        id: 7,
        name: weCallYouAdmin,
    },
    {
        id: 8,
        name: users,
    },
    {
        id: 9,
        name: chat,
    },
    {
        id: 10,
        name: videoCall,
    },
    {
        id: 11,
        name: weCallYou,
    },
    {
        id: 12,
        name: videoAtencion,
    },
    {
        id: 13,
        name: surveys,
    },
    {
        id: 14,
        name: commercialCrm,
    },
    {
        id: 15,
        name: usersCreation,
    },
    {
        id: 16,
        name: ivrTypificationBase,
    },
];
